export default __webpack_public_path__ + "static/media/pakFlag.2ed40344.svg";